<template>
<div class="apps-toolbar-wrap">
	<toolbar>
		<h2><i class="fa" :class="icon ? icon : 'fa-th-large'"></i> {{ title }}</h2>

		<div class="controls d-flex align-items-center flex-wrap">
			<button type="button" class="btn btn-primary mr-2 mb-1 mb-md-0" v-on:click="openPublishModalNew">
				Publish an App...
			</button>
			<nav-tabs :tabs="tabs"></nav-tabs>
		</div>
	</toolbar>

	<modal-dialog title="Publish an App"
		:modal-visible="appPublishModal.visible"
		modal-size="modal-lg"
		confirm-button-text="Publish"
		v-on:closeModal="appPublishModal.visible = false"
		v-on:confirm="saveNewApp">

		<field label="App Name" col-class="col-md-4"
			v-model="appPublishModal.payload.app_name">
			<div class="text-muted">The name that your app will be known as</div>
		</field>

		<hr>

		<field label="Search Keywords" col-class="col-md-4"
			v-model="appPublishModal.payload.search_keywords">
			<div class="text-muted">Provide some comma separated keywords to help users find the app when searching</div>
		</field>

		<field label="Description" col-class="col-md-4"
			v-model="appPublishModal.payload.description">
			<div class="text-muted">A short description describing what your app does</div>
		</field>

		<hr>

		<field label="App Version" col-class="col-md-4"
			v-model="appPublishModal.payload.app_version">
		</field>

		<hr>

		<field label="Source URL" col-class="col-md-4"
			v-model="appPublishModal.payload.src"
			:params="{type:'text',placeholder:'https://yourappdomain.com/'}">
			<div class="text-muted">A full URL to the location of your app. Your app will be injected into {{$store.appName}} via an iframe. This will serve as the iframe src.</div>
		</field>

		<hr>
		<field label="Support Website URL" col-class="col-md-4"
			v-model="appPublishModal.payload.support_website">
			<div class="text-muted">A full URL to the support website for your app, for users to visit to read documentation or find troubleshooting tips</div>
		</field>
		<hr>

		<field label="Logo Source" col-class="col-md-4"
			v-model="appPublishModal.payload.logo_src"
			:params="{type:'text',placeholder:'https://yourappdomain.com/the_app_logo.jpg'}">
			<div class="text-muted">If you want your app to have a logo, link to it here</div>
		</field>
		<hr>

		<field label="Name of Developer" col-class="col-md-4"
			v-model="appPublishModal.payload.developer_name">
		</field>
		<hr>

		<field label="Make the app public for other companies to use" col-class="col-md-9"
			v-model="appPublishModal.payload.is_public"
			:float-control-right='true'
			:params="{type:'boolean'}">

		</field>

		<div class="text-muted">If yes, other companies will see it as an available app, otherwise it will be available only to your company. Even if the app is public, your {{$store.appName}} data will not be shared.</div>

	</modal-dialog>
</div>
</template>

<script>
import NavTabs from "@/layout_fragments/NavTabs"
import Toolbar from "@/layout_fragments/Toolbar"
import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"

export default {

	name: 'AppsToolbar',
	components: {
		Toolbar,
		NavTabs,
		ModalDialog,
		Field,
	},
	props: ["title","icon"],
	data() {
		return {
			appPublishModal: {
				visible: false,
				payload: {}
			}
		}
	},
	computed: {
		tabs() {
			let tabs = [
				{
					label: "Manage Installed Apps",
					icon: "fa-th-large",
					path: "/apps/installed",
					modulePermRequired: ["Settings"]
				},
				{
					label: "Marketplace",
					icon: "fa-th-large",
					path: "/apps/store",
					modulePermRequired: ["Settings"]
				},
				{
					label: "Your Published Apps",
					icon: "fa-book",
					path: "/apps/published",
					modulePermRequired: ["Settings"]
				},
				{
					label: "Integrations",
					icon: "fa-puzzle-piece",
					path: "/apps/integrations"
				}
			]

			if ("AddonApp" in this.$store.company && this.$store.company.AddonApp) {
				let appsInMainSlot = this.$store.company.AddonApp.filter(app => app.ui_location == "Main")

				if (appsInMainSlot.length > 0) {
					tabs.unshift({
						label: "Apps",
						icon: "fa-th-large",
						path: "/apps/main"
					})
				}
			}

			return tabs
		}
	},
	methods: {
		newButton() {
			this.$emit("newButtonClick")
		},
		openPublishModalNew() {
			this.appPublishModal.visible = true
			this.appPublishModal.payload = {}
		},
		openPublishModalForEdit(app) {
			this.appPublishModal.visible = true
			this.appPublishModal.payload = this.cloneObj(app)
		},
		saveNewApp() {
			let vm = this

			this.postData("AddonApp/save",this.appPublishModal.payload,true).then(response => {
				if (response.success) {
					vm.alertSaved("Your app has been published!")
					vm.appPublishModal.visible = false
					vm.$emit("publishedAppSaved")
				}
			})
		}
	}

}
</script>
